import Vue from 'vue';
import VueI18n from 'vue-i18n';
import store from '@/store';
import french from './locales/fr.json';
import english from './locales/en.json';
import spanish from './locales/es.json';

Vue.use(VueI18n);

const organizationId = 'example';

let locale = (navigator.languages && navigator.languages[0]) ||
  navigator.language ||
  navigator.userLanguage;

locale = locale.substring(0, 2);

console.log(locale);

if (store.state.i18n.locales.indexOf(locale) === -1) {
  throw new Error({ message: 'This page could not be found.', statusCode: 404 });
}
// Set locale
store.commit('i18n/SET_LANG', locale);

store.dispatch('i18n/getI18n', { id: organizationId, locale: store.state.i18n.locale });

const i18n = new VueI18n({
  locale: store.state.i18n.locale,
  fallbackLocale: 'fr',
  messages: {
    fr: french.messages,
    en: english.messages,
    es: spanish.messages,
  },
  dateTimeFormats: {
    fr: french.dateTimeFormats,
    en: english.dateTimeFormats,
    es: spanish.dateTimeFormats,
  },
});

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n/index.js